import React from "react";

const Footer = () => {
    return (
        <>
            <footer className="bottom  bg-custom w-100 ">
                <div className="container  py-3  ">
                    <div className="row text-center justify-content-center justify-content-lg-between ">
                        <div className="col-md-2 col-12">
                            <h4 style={{ color: "#fff" }}>{"Adarsh_Sharma_"}</h4>
                        </div>
                        <div className="col-md-3 col-12  pt-2">
                            <p>@Frontendadarshcopyright2017</p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
